import React, { Component } from "react";
import ToggleButton from "../common/Toggle-button";
import { NavLink } from "react-router-dom";
import close from "../assets/close.svg";
import BackArrow from "../common/BackArrow";
import { connect } from "react-redux";
import API from "../common/Api";
import defaultPicture from "../assets/user.svg";
import { Shimmer } from "react-shimmer";
import Input from "../common/Input";
import TimeInput from "../common/Time-input";
import MultiSelect from "../common/MultiSelect";
import moment from 'moment';
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css"; // make sure this is imported

const mapStateToProps = (state) => ({
  headers: state.headers(),
  userProfile: state.userProfile,
  business: state.business,
  opening_hours: state.opening_hours,
  closing_hours: state.closing_hours,
});

export default connect(mapStateToProps)(
  class ManageMember extends Component {
    state = {
      member_identifier: this.props.match.params.member_uuid,
      member_details: {
        role: "",
      },
      hideTime: true,
      showTimeUnavaialbe: true,
      openHours: {},
      weekdayOrder: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      timeOptions: [
        { value: '00:00', label: '12:00 AM' },
        { value: '00:30', label: '12:30 AM' },
        { value: '01:00', label: '1:00 AM' },
        { value: '01:30', label: '1:30 AM' },
        { value: '02:00', label: '2:00 AM' },
        { value: '02:30', label: '2:30 AM' },
        { value: '03:00', label: '3:00 AM' },
        { value: '03:30', label: '3:30 AM' },
        { value: '04:00', label: '4:00 AM' },
        { value: '04:30', label: '4:30 AM' },
        { value: '05:00', label: '5:00 AM' },
        { value: '05:30', label: '5:30 AM' },
        { value: '06:00', label: '6:00 AM' },
        { value: '06:30', label: '6:30 AM' },
        { value: '07:00', label: '7:00 AM' },
        { value: '07:30', label: '7:30 AM' },
        { value: '08:00', label: '8:00 AM' },
        { value: '08:30', label: '8:30 AM' },
        { value: '09:00', label: '9:00 AM' },
        { value: '09:30', label: '9:30 AM' },
        { value: '10:00', label: '10:00 AM' },
        { value: '10:30', label: '10:30 AM' },
        { value: '11:00', label: '11:00 AM' },
        { value: '11:30', label: '11:30 AM' },
        { value: '12:00', label: '12:00 PM' },
        { value: '12:30', label: '12:30 PM' },
        { value: '13:00', label: '1:00 PM' },
        { value: '13:30', label: '1:30 PM' },
        { value: '14:00', label: '2:00 PM' },
        { value: '14:30', label: '2:30 PM' },
        { value: '15:00', label: '3:00 PM' },
        { value: '15:30', label: '3:30 PM' },
        { value: '16:00', label: '4:00 PM' },
        { value: '16:30', label: '4:30 PM' },
        { value: '17:00', label: '5:00 PM' },
        { value: '17:30', label: '5:30 PM' },
        { value: '18:00', label: '6:00 PM' },
        { value: '18:30', label: '6:30 PM' },
        { value: '19:00', label: '7:00 PM' },
        { value: '19:30', label: '7:30 PM' },
        { value: '20:00', label: '8:00 PM' },
        { value: '20:30', label: '8:30 PM' },
        { value: '21:00', label: '9:00 PM' },
        { value: '21:30', label: '9:30 PM' },
        { value: '22:00', label: '10:00 PM' },
        { value: '22:30', label: '10:30 PM' },
        { value: '23:00', label: '11:00 PM' },
        { value: '23:30', label: '11:30 PM' }
      ],
      selectedTimes: {
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        Saturday: [],
        Sunday: []
      },
      una_time_open: {
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
        Saturday: false,
        Sunday: false
      }
    };



    deleteMember = () => {

      let msg = "";
      if (this.state.member_details.number_of_upcoming_aapointments === 0) {
        msg = `Are you sure you want to remove ${this.state.member_details.first_name} ${this.state.member_details.last_name}? This action is NOT reversible.`
      } else {
        msg = `Are you sure you want to remove ${this.state.member_details.first_name} ${this.state.member_details.last_name}? This action is NOT reversible.

        \n\n
This team member has ${this.state.member_details.number_of_upcoming_aapointments} upcoming appointments. To reassign these appointments, please contact support at hello@kindlybook.com`

      }
      confirmAlert({
        customUI: ({ onClose }) => {
          const m = this.state.member_details;

          return (
            <div className="react-confirm-alert-body danger-confirm">
              <h1>Confirm Delete</h1>

              <p>
                Are you sure you want to remove {m.first_name} {m.last_name}? This action is NOT reversible. <br /> <br />

                {m.number_of_upcoming_aapointments > 0 && (
                  <>
                    Please note that this team member has <b style={{ fontWeight: 700 }}>{m.number_of_upcoming_aapointments} upcoming appointment(s). </b>
                    Please contact support at{" "}
                    <a class='co-pink' target="_blank" href="mailto:hello@kindlybook.com">hello@kindlybook.com</a> if you would like to re-assign to another member.
                  </>
                )}
              </p>

              <div className="react-confirm-alert-button-group">
                <button

                  onClick={() => {
                    onClose();
                    this.deleteMemberConfirmed();
                  }}
                >
                  Yes, Delete
                </button>
                <button className="danger" onClick={onClose}>Cancel</button>

              </div>
            </div>
          );
        }
      });


    };


    deleteMemberConfirmed = () => {
      this.setState({ is_loading: true });
      const uuid = this.state.member_identifier;
      API.delete(`business/teams/members/${uuid}`, { headers: this.props.headers, }).then((data) => {
        window.$.notify(`${this.state.member_details.first_name} is no longer on your team`, "success-alert");
        setTimeout(() => { window.location.href = "/business/team"; }, 3000);
      })
        .catch((data) => {
          console.log(data.response.data.message ?? data.message);
          window.$.notify(data.response.data.message ?? data.message, "error-alert");
        }).
        finally(() => { this.setState({ is_loading: false }); });

    }

    getMemberDetails = () => {
      const uuid = this.state.member_identifier;
      API.get(`business/teams/members/${uuid}`, {
        headers: this.props.headers,
      }).then(
        ({ data }) => {
          const member_details = data.data;
          this.setState({
            member_details: {
              ...member_details,
              can_accept_booking: Boolean(member_details.can_accept_booking),
            },
          });
          setTimeout(() => {
            this.setOpeningHours();
          }, 50);

        },
        ({ response }) => {
          window.$.notify(response.data.message, "error-alert ");
        }
      );
    };
    getServices = () => {
      API.get("business/services", {
        headers: this.props.headers,
      }).then(({ data }) => {
        const services = data.data.services;
        this.setState({ services });
      });
    };
    componentDidMount = () => {
      this.setOpeningHours();
      this.getMemberDetails();
      this.getServices();

    };
    addToBookings = (e, service) => {
      let services = this.state.member_details.services;
      if (!services) services = [];
      if (e.currentTarget.checked) {
        services.push(service);
      } else {
        services = services.filter((s) => s.identifier !== service.identifier);
      }
      this.setState({
        member_details: { ...this.state.member_details, services },
      });
    };
    updateSettings = () => {
      const uuid = this.state.member_identifier;
      this.setState({ is_loading: true });
      API.put(
        `business/teams/members/${uuid}`,
        {
          ...this.state.member_details,
          services: this.state.member_details.services?.map((s) => {
            return s.id;
          }),
        },
        {
          headers: this.props.headers,
        }
      )
        .then(
          ({ data }) => {
            window.$.notify(
              `Updated settings for "${this.state.member_details.first_name}"`,
              "success-alert"
            );
          },
          () => {
            window.$.notify("Something went wrong", "error-alert");
          }
        )
        .finally(() => {
          this.setState({ is_loading: false });
        });
    };

    setOpeningHours = () => {
      this.setState({ hideTime: true });
      const opening_hours_state = {};
      const opening_hours = this.props.business.opening_hours;
      let una_time_open = this.state.una_time_open;
      if (opening_hours && Array.isArray(opening_hours)) {
        opening_hours.forEach((entry) => {
          const { week_day, opening_time, closing_time } = entry;

          // Set only the FIRST entry per day as an array with exactly one object
          let match = false;
          if (this.state.member_details && this.state.member_details.opening_hours) {
            match = this.state.member_details.opening_hours.find(
              (item) => item.week_day === week_day
            );
          }
          if (match) {
            opening_hours_state[week_day] = [
              {
                from: match.opening_time,
                to: match.closing_time
              }
            ];
            una_time_open[week_day] = true;

          } else {
            opening_hours_state[week_day] = [
              {
                from: opening_time,
                to: closing_time
              }
            ];
          }


          // If day already has an entry, skip
          if (opening_hours_state.hasOwnProperty(week_day)) {
            return;
          }
        });

      }

      if (this.state.member_details.unavailable_hours
      ) {
        this.setState({ selectedTimes: this.state.member_details.unavailable_hours });
      }
      this.setState({ openHours: opening_hours_state });
      this.setState({ hideTime: false });
      this.setState({ una_time_open: una_time_open });
    };

    updateHours = (hoursState) => {
      this.setState({ showTimeUnavaialbe: false });
      setTimeout(() => {
        const updatedOpenHours = { ...this.state.openHours };
        let new_open_hour = {};
        for (const [day, timeArray] of Object.entries(hoursState)) {

          if (hoursState[day] === false) {
            delete this.state.openHours[day];
            delete updatedOpenHours[day];
            let opening_hours = this.state.member_details.opening_hours;
            opening_hours.forEach((hours_, key_) => {
              if (hours_.week_day === day && timeArray === false) {
                // this.setState(this.state.una_time_open,{...this.state.una_time_open,[day]: false});
                this.setState({
                  una_time_open: {
                    ...this.state.una_time_open,
                    [day]: false
                  }
                });
              }
            });


            // delete opening_hours[day];
            this.setState({ openHours: { ...this.openHours, ...updatedOpenHours } })
            this.setState({
              una_time_open: {
                ...this.state.una_time_open,
                [day]: false
              }
            });
            continue;
          }

          this.setState({
            una_time_open: {
              ...this.state.una_time_open,
              [day]: true
            }
          });
          const time = timeArray[0];

          let business_opening_hours = this.props.business.opening_hours.find(
            (item) => item.week_day === day
          );


          if (time.from < business_opening_hours.opening_time ||
            time.to > business_opening_hours.closing_time) {

            updatedOpenHours[day] = [{ from: business_opening_hours.opening_time, to: time.from && business_opening_hours.closing_time }];
            window.$.notify("Member availabilty can not be outisde business open and closing hours", "error-alert");

          }


          if (time.from === time.to) {
            return window.$.notify("Opening and closing time can not be same.", "error-alert");
          }
          if (time.to < time.from) {
            return window.$.notify("Closing time can not be earlier than Opening time.", "error-alert");
          }
          if (time.from > time.to) {
            return window.$.notify("Opening time can not be later than Closing time.", "error-alert");
          }
          this.setState({ openHours: { ...updatedOpenHours, [day]: hoursState[day] } })
        }
        this.setState({ hideTime: false });
        this.setState({ showTimeUnavaialbe: true });

      }, 100);


    };
    saveMemberDays = (ev) => {
      ev.preventDefault();
      //clear errors
      this.setState({ loading: true, errors: {} });
      const formData = {
        member_id: this.state.member_details.id,
        opening_hours: [],
        unavailable_hours: this.state.selectedTimes,
      };
      // return
      let can_save = true;

      Object.keys(this.state.openHours).forEach((day) => {
        if (this.state.openHours[day] !== false) {
          this.state.openHours[day].forEach((hour) => {
            if (hour.from === hour.to) {
              can_save = false;
              return window.$.notify("Opening and closing time can not be same.", "error-alert");
            }
            if (hour.to < hour.from) {
              can_save = false;
              return window.$.notify("Closing time can not be earlier than Opening time.", "error-alert");
            }
            if (hour.from > hour.to) {
              can_save = false;
              return window.$.notify("Opening time can not be later than Closing time.", "error-alert");
            }

            // Check una_time_open before pushing
            if (this.state.una_time_open[day]) {
              const formattedDay = day[0].toUpperCase() + day.slice(1);

              // Avoid duplicates
              const alreadyExists = formData.opening_hours.some(
                (entry) =>
                  entry.week_day === formattedDay &&
                  entry.opening_time === hour.from &&
                  entry.closing_time === hour.to
              );

              if (!alreadyExists) {
                formData.opening_hours.push({
                  week_day: formattedDay,
                  opening_time: hour.from,
                  closing_time: hour.to,
                });
              }
            }
          });
        }
      });


      if (!can_save) {
        this.setState({ loading: false });
        return false;
      }


      API({
        method: "PUT",
        url: "business/member_opening_hours",
        headers: { ...this.props.headers, Accept: "*/*" },
        data: formData,
      })
        .then(
          ({ data }) => {
            if (data.success) {
              window.$.notify("Member availabilty settings updated", "success-alert");
            }
          },
          ({ response }) => {
            if (response.data?.errors) {
              response.data.errors.map((error) =>
                this.setState({
                  errors: {
                    ...this.state.errors,
                    [error.field]: error.message,
                  },
                })
              );
            }
          }
        )
        .finally(() => {
          this.setState({ loading: false });
        });

    };

    determine_default = (service) => {
      let bool = false;
      if (this.state.member_details.services) {
        this.state.member_details.services.map((s) => {
          if (s.identifier === service.identifier) {
            bool = true;
          }
          return bool;
        });
      }
      return bool;
    };
    handleChange = ({ currentTarget: { name, value } }) => {
      this.setState({
        member_details: {
          ...this.state.member_details,
          [name]: value,
        },
      });
    };
    capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1);

    handleTimeChange = (day, selectedOptions) => {
      const dayKey = this.capitalize(day); // ensure key matches weekdayOrder
      this.setState((prevState) => ({
        selectedTimes: {
          ...prevState.selectedTimes,
          [dayKey]: selectedOptions || [],
        },
      }
      ));
    };

    render() {
      return (
        <div className="dsk-modal-rapper">
          <NavLink
            className="absolute-bg"
            to={{
              pathname: "/team",
            }}
          ></NavLink>

          <div className="dsk-modal manage-member-page" >
            {window.innerWidth >= 600 ? (
              <NavLink
                className="close-btn dsk"
                to={{
                  pathname: "/team",
                }}
              >
                <img src={close} alt="" srcSet="" />
              </NavLink>
            ) : (
              ""
            )}
            <div className="flex center">
              <BackArrow />
              <h1 class="section-title">Manage team member</h1>
            </div>

            <div className="details card">
              {this.state.member_details.identifier && this.state.services ? (
                <>
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      this.updateSettings();
                    }}
                  >
                    <div className="member flex">
                      <span
                        className="dp-rapper"
                        style={{
                          backgroundImage: `url("${this.state.member_details.profile_picture ||
                            defaultPicture
                            }")`,
                        }}
                      ></span>
                      <div>
                        <p className="name">
                          {this.state.member_details.first_name}{" "}
                          {this.state.member_details.last_name}
                        </p>
                        <p className="small">
                          {this.state.member_details.email}
                        </p>
                        <p className="small">
                          {this.state.member_details.number_of_bookings}{" "}
                          Booking(s)
                        </p>

                        {this.state.member_details.identifier !== this.props.userProfile.member.identifier &&
                          <p className="small">
                            <button className="co-red" style={{ color: 'red', marginTop: '10px', fontSize: '12px' }} type="button" onClick={this.deleteMember}>
                              Delete team member
                            </button>
                          </p>}
                      </div>
                    </div>

                    <div className="toggle-container flex space-btw center border-btm-none">
                      <Input
                        label="Title"
                        placeholder="e.g. Stylist"
                        name="role"
                        onChange={(val) => {
                          // this.state.member_details.role = val;
                          this.setState({
                            member_details: {
                              ...this.state.member_details,
                              role: val?.target?.value,
                            },
                          })
                          return val?.target?.value;
                        }}
                        value={this.state.member_details.role}
                        // maxlength="36"
                        required
                      />
                    </div>

                    <div className="toggle-container flex space-btw center">
                      <p className="title">Available for bookings</p>
                      <ToggleButton
                        data_open={Boolean(
                          this.state.member_details.can_accept_booking
                        )}
                        OnChange={(can_accept_booking) =>
                          this.setState({
                            member_details: {
                              ...this.state.member_details,
                              can_accept_booking,
                            },
                          })
                        }
                      />
                    </div>



                    <div className="footer flex space-btw">
                      <br />

                      <button
                        className={`default ${this.state.is_loading ? "loading" : ""
                          }`}
                      >
                        Save Changes
                      </button>
                    </div>
                  </form>
                </>
              ) : (
                <>
                  <Shimmer
                    height={150}
                    className="shimmerLoader r-shimer-service r-shimer-member"
                  />
                  <Shimmer
                    height={60}
                    className="shimmerLoader r-shimer-service r-shimer-member"
                  />
                </>
              )}
            </div>

            {this.state.member_details.can_accept_booking ? (
              <div className="details card">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.updateSettings();
                  }}
                >
                  <p class="title">Services</p>

                  <div className="services-row">
                    {this.state.services?.map((service) => (
                      <CheckBox
                        title={service.name}
                        service={service}
                        id={service.identifier}
                        api_id={service.id}
                        defaultChecked={this.determine_default(service)}
                        name="service"
                        onChange={(e, ev) => {
                          this.addToBookings(e, ev);
                        }}
                      // required
                      />
                    ))}
                  </div>

                  <div className="footer flex space-btw">
                    <br />
                    <button
                      className={`default ${this.state.is_loading ? "loading" : ""
                        }`}
                    >
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            ) : (
              ""
            )}
            {this.state.member_details.can_accept_booking ?
              <div className="details card">
                {this.state.member_details.identifier ? (
                  <>
                    <p class="title">Available Days & Hours</p>
                    <form
                      onSubmit={this.saveMemberDays}
                      className="restrict"
                      encType="multipart/form-data"
                    >
                      <div >
                        {
                          !this.state.hideTime && this.state.member_details && this.props.business.opening_hours
                            ?.sort(
                              (a, b) =>
                                this.state.weekdayOrder.indexOf(a.week_day) - this.state.weekdayOrder.indexOf(b.week_day)
                            )
                            .map((hours) => {
                              const match = this.state.member_details.opening_hours.find(
                                (item) => item.week_day === hours.week_day
                              );
                              return (

                                <>
                                  <TimeInput
                                    key={hours.week_day}
                                    label={hours.week_day}
                                    defaultstate={match ? "open" : 'closed'}
                                    openedName="Available"
                                    closedName="Unavailable"
                                    updateHours={this.updateHours}
                                    openHours={this.state.openHours[hours.week_day] || []}
                                  />
                                  {/* {this.state.una_time_open[hours.week_day] + "_"} {hours.week_day} */}
                                  {this.state.una_time_open[hours.week_day] ?
                                    <>
                                      {this.state.showTimeUnavaialbe ?
                                        <div className="unavaialbe_hours_box">  <b>Unavailable time</b>

                                          <MultiSelect
                                            isMulti
                                            value={this.state.selectedTimes[hours.week_day] || []}
                                            onChange={(options) => this.handleTimeChange(hours.week_day, options)}
                                            options={
                                              this.state.timeOptions.filter(option => {
                                                const openHours = this.state.openHours[hours.week_day] || {};

                                                const business_opening_hours = this.props.business.opening_hours.find(
                                                  (item) => item.week_day === hours.week_day
                                                );
                                                const from = openHours[0]?.from ?? business_opening_hours.opening_time; // "09:00 AM"
                                                const to = openHours[0]?.to ?? business_opening_hours.closing_time;     // "05:00 PM"
                                                if (!from || !to) return false;
                                                // Parse openHours to moment objects
                                                const format12h = "hh:mm A";
                                                const fromMoment = moment(from, format12h);
                                                const toMoment = moment(to, format12h);

                                                // option.value is "HH:mm" 24-hour format, e.g. "13:30"
                                                // parse option.value to moment using 24-hour format
                                                const optionMoment = moment(option.value, "HH:mm");

                                                // Check if optionMoment is between from and to (inclusive)
                                                return optionMoment.isSameOrAfter(fromMoment) && optionMoment.isSameOrBefore(toMoment);
                                              })
                                            }
                                            placeholder="Select one or more time"
                                            isClearable
                                          /> </div> : ""}
                                    </> : ""}
                                </>
                              );
                            })}
                        <br></br>
                        <div className="flex right space-btw">
                          <br></br>
                          <button
                            className={`default ${this.state.loading ? "loading" : ""
                              }`}
                          >
                            Save Changes
                          </button>
                        </div>
                      </div>
                    </form>
                  </>
                ) : (
                  <>
                    <Shimmer
                      height={150}
                      className="shimmerLoader r-shimer-service r-shimer-member"
                    />
                    <Shimmer
                      height={60}
                      className="shimmerLoader r-shimer-service r-shimer-member"
                    />
                  </>
                )}
              </div> : ''
            }
          </div>
        </div >
      );
    }
  }
);

function CheckBox({ title, api_id, service, onChange, ...props }) {
  return (
    <div className="service flex center">
      <span className="check-box">
        <input
          type="checkbox"
          value={api_id}
          onChange={(e) => onChange(e, service)}
          {...props}
        />
        <span className="tick"></span>
      </span>
      <label htmlFor={{ ...props }["id"]}>{title}</label>
    </div>
  );
}
